import {DayName} from '@lib/infrastructure';
import {WorkingHours} from '@lib/store';

export const timeOptionsBetween = (start: number, end: number) =>
  Array.from({length: (end - start) * 2}, (_, i) => {
    const h = start + Math.floor(i / 2);
    const hh = h.toString().padStart(2, '0');
    const mm = i % 2 == 0 ? '00' : '30';

    return `${hh}:${mm}:00`;
  });

export const localTimeDisplayName = (localTime: string) => {
  if (!localTime.match(/^\d\d\:\d\d:\d\d$/)) {
    throw new Error('Please provide a string in the shape of hh:mm:ss');
  }

  return localTime.slice(localTime.startsWith('0') && !localTime.startsWith('00') ? 1 : 0, -3);
};

export const constructWorkingHoursLabel = (workingHours: WorkingHours | null) => {
  if (workingHours === null) return '';

  const {startTimeLocal, endTimeLocal} = workingHours.days[0].times[0];

  return [startTimeLocal, endTimeLocal].map(localTimeDisplayName).join(' - ');
};

/**
 * Construct a complete working hours definition out of just 3 values. Useful as long as our UI does not support
 * configuring a complete week's working hours config
 * @param timeZoneId An ianaTimeZoneId that appears in the list of timezones defined on our server
 * @param dayStart A timestamp in the hh:mm:ss format
 * @param dayEnd A timestamp in the hh:mm:ss format
 * @returns An API compatible working hours model
 */
export const createWorkingHoursDto = (timeZoneId: string, dayStart: string, dayEnd: string): WorkingHours => {
  const dayNames: DayName[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  return {
    timeZoneId,
    days: dayNames.map((day: DayName) => ({dayName: day, times: [{startTimeLocal: dayStart, endTimeLocal: dayEnd}]})),
  };
};
